import { createClient } from '@supabase/supabase-js';

const COOKIE_DOMAIN = '.doctorgemma.com';

function getCookieDomain() {
  if (typeof window === 'undefined') return undefined;
  const { hostname } = window.location;
  // Only scope the cookie to .doctorgemma.com when actually running on a
  // doctorgemma.com subdomain — on localhost or a Cloudflare Pages preview
  // (*.pages.dev) a mismatched Domain attribute makes the browser silently
  // drop the cookie, which would break auth there entirely.
  return hostname.endsWith('doctorgemma.com') ? COOKIE_DOMAIN : undefined;
}

function getCookie(name) {
  const escaped = name.replace(/([.$?*|{}()[\]\\/+^])/g, '\\$1');
  const match = document.cookie.match(new RegExp(`(?:^|; )${escaped}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function setCookie(name, value, days) {
  const domain = getCookieDomain();
  const maxAge = days * 24 * 60 * 60;
  let cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
  if (domain) cookie += `; domain=${domain}`;
  if (window.location.protocol === 'https:') cookie += '; Secure';
  document.cookie = cookie;
}

function removeCookie(name) {
  const domain = getCookieDomain();
  let cookie = `${name}=; path=/; max-age=0`;
  if (domain) cookie += `; domain=${domain}`;
  document.cookie = cookie;
}

// Supabase's auth storage adapter (getItem/setItem/removeItem). Using
// cookies instead of localStorage is what lets a login on onlineapps.
// doctorgemma.com carry over to tools.doctorgemma.com and future subdomain
// apps. Note: the session blob (access + refresh token) is small enough to
// fit comfortably under the ~4KB per-cookie limit today, but if Supabase
// ever grows the JWT (more custom claims, etc.) this is the spot to watch.
const cookieStorage = {
  getItem: (key) => getCookie(key),
  setItem: (key, value) => setCookie(key, value, 100),
  removeItem: (key) => removeCookie(key),
};

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL,
  process.env.REACT_APP_SUPABASE_ANON_KEY,
  {
    auth: {
      storage: cookieStorage,
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  }
);
